// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    /* .body{
        position: fixed;
        width: 100%;
        margin-top: 65px;
    } */

    .Layout_withoutMenu__2oNQp{
        display: grid;
        grid-template-columns: 0 100%;
        transition: 0.5s ;
    }
    .Layout_withMenu__RIFl1{
        display: grid;
        grid-template-columns: 20% 80%;
    }  
    
    /* .withoutMenu{
        min-height: 780px;
        overflow-y: hidden;
    }   */
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    /* .body{
         margin-top: 65px; 
        max-height: 700px;
        overflow-y: hidden;
    } */

    .Layout_withoutMenu__2oNQp{
        display: grid;
        grid-template-columns: 0 100%;
        transition: 1.0s ;
    }
    .Layout_withMenu__RIFl1{
        display: grid;
        grid-template-columns: 25% 75%;
    }  
    
    /* .withoutMenu{
        min-height: 700px;
    }  */
}

/*MOBILE*/
@media screen and (max-width:767px){
    /* .body{
        margin-top: 12.5%;
        max-height:650px;
        min-height: 600px;
        overflow-y: hidden;
    } */

    .Layout_body__tK2jF{
        height: 100vh;
    }
    .Layout_withoutMenu__2oNQp{
        display: grid;
        grid-template-columns: 0 100%;
        transition: 1.0s ;
    }
    /* .withMenu{
      display: grid; 
      grid-template-columns: 0 100%;
    }   */
    
    /* .withoutMenu{
        min-height: 700px;
    }  */
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;;;;OAIG;;IAEH;QACI,aAAa;QACb,6BAA6B;QAC7B,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;;;SAGK;AACT;;AAEA,SAAS;AACT;IACI;;;;OAIG;;IAEH;QACI,aAAa;QACb,6BAA6B;QAC7B,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;;QAEI;AACR;;AAEA,SAAS;AACT;IACI;;;;;OAKG;;IAEH;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,6BAA6B;QAC7B,iBAAiB;IACrB;IACA;;;SAGK;;IAEL;;QAEI;AACR","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    /* .body{\n        position: fixed;\n        width: 100%;\n        margin-top: 65px;\n    } */\n\n    .withoutMenu{\n        display: grid;\n        grid-template-columns: 0 100%;\n        transition: 0.5s ;\n    }\n    .withMenu{\n        display: grid;\n        grid-template-columns: 20% 80%;\n    }  \n    \n    /* .withoutMenu{\n        min-height: 780px;\n        overflow-y: hidden;\n    }   */\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    /* .body{\n         margin-top: 65px; \n        max-height: 700px;\n        overflow-y: hidden;\n    } */\n\n    .withoutMenu{\n        display: grid;\n        grid-template-columns: 0 100%;\n        transition: 1.0s ;\n    }\n    .withMenu{\n        display: grid;\n        grid-template-columns: 25% 75%;\n    }  \n    \n    /* .withoutMenu{\n        min-height: 700px;\n    }  */\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    /* .body{\n        margin-top: 12.5%;\n        max-height:650px;\n        min-height: 600px;\n        overflow-y: hidden;\n    } */\n\n    .body{\n        height: 100vh;\n    }\n    .withoutMenu{\n        display: grid;\n        grid-template-columns: 0 100%;\n        transition: 1.0s ;\n    }\n    /* .withMenu{\n      display: grid; \n      grid-template-columns: 0 100%;\n    }   */\n    \n    /* .withoutMenu{\n        min-height: 700px;\n    }  */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"withoutMenu": `Layout_withoutMenu__2oNQp`,
	"withMenu": `Layout_withMenu__RIFl1`,
	"body": `Layout_body__tK2jF`
};
export default ___CSS_LOADER_EXPORT___;
